function n(a,r){throw new Error(r??`Unexpected value: ${a}`)}function t(a,...r){return(...e)=>a(...r,...e)}export{n as assertExhaustive,t as curry};
//# sourceMappingURL=utils.js.map